/* eslint-disable jsx-a11y/anchor-has-content */
import { useOnlineSchedulerLocation } from 'app/components/online-scheduler-location/useOnlineSchedulerLocation'
import { OnlineSchedulerLocationComponent } from 'app/components/online-scheduler-location/OnlineSchedulerLocationComponent'

export default function OnlineSchedulerLocation() {
  const hookData = useOnlineSchedulerLocation()
  return <OnlineSchedulerLocationComponent {...hookData} />
}
